import "./style.scss";
import Switch from "@components/Switch";
import SectionHeader from "../../../components/SectionHeader";
import { useQuery } from "@tanstack/react-query";
import {
  DETAILS_CACHE_TIME,
  DETAILS_STALE_TIME,
  getUserDetails,
  DETAILS_REFETCH_INVERVAL,
} from "../../../api/consumer";
import skinsData from "./data";
import { useState, useEffect } from "react";
import { FORCE_SKIN_END, FORCE_SKIN_ID } from "@app/Constants";

export default function MenuSkins() {
  const { data } = useQuery({
    queryKey: ["user-details"],
    queryFn: getUserDetails,
    refetchInterval: DETAILS_REFETCH_INVERVAL,
    staleTime: DETAILS_STALE_TIME,
    cacheTime: DETAILS_CACHE_TIME,
  });

  const [activeSkin, setActiveSkin] = useState(null);

  const skins = skinsData;
  const isForcePeriod = new Date() < FORCE_SKIN_END;

  useEffect(() => {
    const saved = localStorage.getItem("activeSkin");
    setActiveSkin(saved || null);
  }, []);

  useEffect(() => {
    const handler = () => {
      const saved = localStorage.getItem("activeSkin");
      setActiveSkin(saved || null);
    };

    window.addEventListener("skinChange", handler);
    return () => window.removeEventListener("skinChange", handler);
  }, []);

  useEffect(() => {
    if (!data || !activeSkin) return;

    if (isForcePeriod && activeSkin === FORCE_SKIN_ID) {
      return;
    }

    if (!data.skin?.[activeSkin]) {
      setActiveSkin(null);
      localStorage.setItem("activeSkin", "");
      window.dispatchEvent(new CustomEvent("skinChange"));
    }
  }, [data, activeSkin, isForcePeriod]);

  const toggleSkin = (id) => {
    if (isForcePeriod) return;

    const apiHasSkin = !!data?.skin?.[id];
    if (!apiHasSkin) return;

    if (activeSkin === id) {
      setActiveSkin(null);
      localStorage.setItem("activeSkin", "");
      window.dispatchEvent(new CustomEvent("skinChange"));
      return;
    }

    setActiveSkin(id);
    localStorage.setItem("activeSkin", id);
    window.dispatchEvent(new CustomEvent("skinChange"));
  };

  function SkinCard({ name, skin, id }) {
    const apiHasSkin = !!data?.skin?.[id];
    const hasSkin = isForcePeriod
      ? id === FORCE_SKIN_ID
      : apiHasSkin;

    const isActive = hasSkin && activeSkin === id;
    const isForced = isForcePeriod && id === FORCE_SKIN_ID;

    const isGloballyLocked = isForcePeriod;

    return (
      <div
        className={`skin-card ${!hasSkin || isGloballyLocked ? "disabled" : ""
          } ${isActive ? "active" : ""} ${isForced ? "forced" : ""}`}
      >
        <div className="skin-card-header">
          <Switch
            checked={isActive}
            onChange={() => toggleSkin(id)}
            name={id}
            register={() => { }}
            role="none"
            disabled={!hasSkin || isGloballyLocked}
          />
          <p>
            {name}
            {isForced && <span className="skin-badge">Fixiert</span>}
          </p>
        </div>
        <div className="skin-card-image">
          <img src={skin} alt={name} />
        </div>
      </div>
    );
  }

  return (
    <div className="menu-skins-wrapper">
      <div className="section-header-wrapper-desktop">
        <strong>Deine Kollektion:</strong>
      </div>

      <div className="profile-section"></div>

      <div className="section-header-wrapper-mobile">
        <strong>Deine Kollektion:</strong>
      </div>

      <div className="menu-skins-inner">
        <div className="cards-wrapper">
          {skins
            .filter((skin) => {
              const apiHasSkin = data?.skin?.[skin.id];

              if (isForcePeriod && skin.id === FORCE_SKIN_ID) {
                return true;
              }

              return apiHasSkin;
            })
            .map((skin) => (
              <SkinCard
                key={skin.id}
                name={skin.name}
                skin={skin.img}
                id={skin.id}
              />
            ))}
        </div>

        <p className="menu-skins-text">
          Menü-Skins funktionieren <strong>lokal</strong> – das heißt, der Skin,
          den du aktivierst, erscheint nur auf dem Gerät und im Browser, wo du
          ihn eingeschaltet hast.
        </p>

        <p className="menu-skins-text">
          Von woanders eingeloggt? Kein Problem –{" "}
          <strong>einfach hier wieder aktivieren!</strong>
        </p>
      </div>
    </div>
  );
}
